export default "__VITE_ASSET__B74xDI5q__"